import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import ButtonBlue from "../../components/Button/ButtonBlue";
import "../../styles/journal.styles.scss";
import * as AiIcons from "react-icons/ai";
import { getPosts, POST_DELETED } from "../../redux/actions/journal";
import SearchBar from "../../components/Searchbar";
import { staticFiles } from "../../components/Helpers/Static";
import Swal from "sweetalert2";
import {
  BgBlue,
  ButtonGridActiveNew,
  ButtonGridNew,
  MenuItemCard,
  MenuItemDiv,
  ButtonCommonTopNew,
  ButtonCommonDelete,
  ButtonCommonTopGrey,
  SideBarActiveDivNew,
  SideBarNormalDivNew,
} from "../Theme";
import {
  fillList,
  hideShareto,
  showShareto,
} from "../../redux/actions/sharePost";
import ShareTo from "../Community/ShareTo";
import { tokenAuthorize } from "../../components/Helpers/Common";
import { ViewList, ViewModule } from "@material-ui/icons";
import {
  getUserPreference,
  putUserPreference,
  getUserNavigationConfrimPopup,
} from "../../redux/actions/commonAction";
import JournalGridCard from "./JournalGridCard";
import { getShowcaseDetails } from "../../redux/actions/showcase";
import JournalCards from "./JournalCards";
import {
  getReflectionFeedbackHistory,
  getReflectionFeedbackModels,
} from "../../redux/actions/reflectionFeedback";
import SidebarJournal from "./SideBarJournal.js";
import ShareIcon from "@mui/icons-material/Share";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { FaTrashAlt } from "react-icons/fa";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import RemoveDoneIcon from "@mui/icons-material/RemoveDone";
const JOURNALSIDEBARDATA = [
  {
    title: "Shared with individual",
    iconClosed: <AiIcons.AiFillCaretRight />,
    iconOpened: <AiIcons.AiFillCaretDown />,
    item: [],
    open: true,
  },
  {
    title: "Shared in community",
    iconClosed: <AiIcons.AiFillCaretRight />,
    iconOpened: <AiIcons.AiFillCaretDown />,
    item: [],
    open: false,
  },
  {
    title: "Courses",
    iconClosed: <AiIcons.AiFillCaretRight />,
    iconOpened: <AiIcons.AiFillCaretDown />,
    item: [],
    open: false,
  },
  {
    title: "Topics",
    iconClosed: <AiIcons.AiFillCaretRight />,
    iconOpened: <AiIcons.AiFillCaretDown />,
    item: [],
    open: false,
  },
  // {
  //   title: "Values/Competencies",
  //   iconClosed: <AiIcons.AiFillCaretRight />,
  //   iconOpened: <AiIcons.AiFillCaretDown />,
  //   item: [],
  //   open: false,
  // },
  {
    title: "Personal Tags",
    iconClosed: <AiIcons.AiFillCaretRight />,
    iconOpened: <AiIcons.AiFillCaretDown />,
    item: [],
    open: false,
  },
  // {
  //     title: 'Shared in community',
  //     iconClosed: <AiIcons.AiFillCaretRight />,
  //     iconOpened: <AiIcons.AiFillCaretDown />,
  //     item: [],
  //     open: false,
  // },
];

function Journal(props) {
  const { path } = useRouteMatch();

  const dispatch = useDispatch();
  const location = useLocation();
  const posts = useSelector((state) => state.journal.posts);
  const totalPosts = useSelector((state) => state.journal.totalPosts);
  const isChange = useSelector((state) => state.journal.change);
  const currentFilter = useSelector((state) => state.journal.currentSelection);
  const postValues = useSelector((state) => state.showcase.values);
  const historyEnabled = useSelector((state) => state.journal.historyEnabled);

  const [postSelection, setPostSelection] = useState([]);
  const history = useHistory();
  const [filterOptions, setFilterOptions] = useState(JOURNALSIDEBARDATA);
  const [searchField, setSearchField] = useState("");
  const [selectedOption, setSelectedOption] = useState({
    type: -1,
    value: 0,
  });
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortBy, setSortBy] = useState("recentDate");
  const [selectEnabled, setSelectEnabled] = useState(false);
  const [filteredPost, setFilteredPost] = useState([]);
  const [dropdown, setDropdown] = useState(false);

  const [sharedWithOthers, setsharedWithOthers] = useState([]);
  const [sharedInCommunity, setsharedInCommunity] = useState([]);
  const [isGrid, setisGrid] = useState(true);
  const [isMobile, setisMobile] = useState(true);
  const pagePreference = useSelector(
    (state) => state.commonData.pagePreference
  );

  const [isMobile1, setisMobile1] = useState(false);
  const [isMobile2, setisMobile2] = useState(false);
  const [isMobile3, setisMobile3] = useState(false);
  const [isMobile4, setisMobile4] = useState(false);
  const [sortMenu, setSortMenu] = useState(null);

  const LOADING_GIF = staticFiles.loading;

  const userTheme = useSelector((state) => state.auth.theme);
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);

  const useStyles = makeStyles((theme) => ({
    customMenu: {
      backgroundColor:
        isDefaultTheme == false && userTheme
          ? `${userTheme?.color3} !important`
          : "white !important",
      width: "200 !important;",
    },
    nestedMenu: {
      pointerEvents: "none",
      paddingRight: 20, // add right space
      minWidth: 180,
    },
    nestedContent: {
      pointerEvents: "auto",
    },
  }));

  const [groupedValues, setGroupedValues] = useState([]);

  useEffect(() => {
    if (currentFilter) {
      if (currentFilter.sortBy1) {
        setSortBy(currentFilter.sortBy1);
      }
      if (currentFilter.sortOrder) {
        setSortOrder(currentFilter.sortOrder);
      }
      // setSelectedOption(currentFilter);
    }
  }, []);

  useEffect(() => {
    dispatch(getShowcaseDetails());
    dispatch(getPosts());
    dispatch(getUserNavigationConfrimPopup(false));
  }, [dispatch]);

  useEffect(() => {
    getSharedData();
  }, [isChange]);

  const getSharedData = () => {
    axios
      .get(serverUrl.sharedPosts)
      .then((res) => {
        if (res.status === 200) {
          setsharedWithOthers(res.data?.shared_with_others);
          setsharedInCommunity(res.data?.shared_in_community);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  };

  useEffect(() => {
    setFilterOptions((prevState) => {
      let currentOptions = [...prevState];
      let ids = { values: [], events: [], courses: [], hashtags: [] };
      currentOptions[0].item = sharedWithOthers.map((data) => {
        return {
          id: data.user_id,
          value: data.user_name,
          count: data.reflection_id.length ? data.reflection_id.length : 0,
        };
      });
      currentOptions[1].item = sharedInCommunity.map((data) => {
        return {
          id: data.group_id,
          value: data.group_name,
          count: data.reflection_id.length ? data.reflection_id.length : 0,
        };
      });
      currentOptions[0].item.sort((a, b) =>
        String(a.value).localeCompare(String(b.value))
      );
      currentOptions[1].item.sort((a, b) =>
        String(a.value).localeCompare(String(b.value))
      );
      currentOptions[2].item = [];
      currentOptions[3].item = [];
      currentOptions[4].item = [];
      // currentOptions[5].item = [];

      // postValues?.map((r) => (
      //     r?.children?.map((item) => (
      //         item?.children?.map((data) => (
      //             currentOptions[4].item.push({ id: data.value_id, value: data.name, count: data.count })
      //         ))
      //     ))
      // ))
      // debugger;
      // let newPostValues = postValues.map((data) => {
      //   data.children.map((childData) => {
      //     return {
      //       title: data.name + ": " + childData.name,
      //       iconClosed: <AiIcons.AiFillCaretRight />,
      //       iconOpened: <AiIcons.AiFillCaretDown />,
      //       item: childData.children.map((innerChildData) => {
      //         return {
      //           id: innerChildData.value_id,
      //           value: innerChildData.name,
      //           count: innerChildData.count,
      //         };
      //       }),
      //       open: false,
      //     };
      //   });
      // });

      const newPostValues = postValues.flatMap((data) =>
        data.children.map((childData) => ({
          title: `${data.name}: ${childData.name}`,
          iconClosed: <AiIcons.AiFillCaretRight />,
          iconOpened: <AiIcons.AiFillCaretDown />,
          item: childData.children
            .filter((innerChildData) => innerChildData.count > 0)
            .map((innerChildData) => ({
              id: innerChildData.value_id,
              value: innerChildData.name,
              count: innerChildData.count,
            })),
          open: false,
        }))
      );
      setGroupedValues(newPostValues);


      // postValues?.map((r) =>
      //   r?.children?.map((item) =>
      //     item?.children?.map((data) => {
      //       if (data.count > 0) {
      //         currentOptions[4].item.push({
      //           id: data.value_id,
      //           value: data.name,
      //           count: data.count,
      //         });
      //       }
      //     })
      //   )
      // );
      // currentOptions[4].item.sort((a, b) =>
      //   String(a.value).localeCompare(String(b.value))
      // );

      posts.forEach((post) => {
        post.courses.forEach((course) => {
          if (!ids.courses.includes(course.id)) {
            ids.courses.push(course.id);
            currentOptions[2].item.push({
              id: course.id,
              value: course.value,
              count: 0,
            });
          }
          if (ids.courses.includes(course.id)) {
            let index = currentOptions[2].item.findIndex(
              (data) => course.id === data.id
            );
            currentOptions[2].item[index].count += 1;
          }
        });
        currentOptions[2].item.sort((a, b) =>
          String(a.value).localeCompare(String(b.value))
        );

        post.events.forEach((event) => {
          if (!ids.events.includes(event.id)) {
            ids.events.push(event.id);
            currentOptions[3].item.push({
              id: event.id,
              value: event.value,
              count: 0,
            });
          }
          if (ids.events.includes(event.id)) {
            let index = currentOptions[3].item.findIndex(
              (data) => event.id === data.id
            );
            currentOptions[3].item[index].count += 1;
          }
        });
        currentOptions[3].item.sort((a, b) =>
          String(a.value).localeCompare(String(b.value))
        );
        // post.values.forEach(value => {
        //     if (!ids.values.includes(value.id)) {
        //         ids.values.push(value.id)
        //         currentOptions[4].item.push({ id: value.id, value: value.value, count: 0 })
        //     }
        //     if (ids.values.includes(value.id)) {
        //         let index = currentOptions[4].item.findIndex((data) => value.id === data.id);
        //         currentOptions[4].item[index].count += 1;
        //     }
        // })

        post.hashtag.forEach((tag) => {
          if (tag.length > 0 && !ids.hashtags.includes(tag.toLowerCase())) {
            ids.hashtags.push(tag.toLowerCase());
            currentOptions[4].item.push({
              id: tag.toLowerCase(),
              value: tag,
              count: 0,
            });
          }
          if (ids.hashtags.includes(tag.toLowerCase())) {
            let index = currentOptions[4].item.findIndex(
              (data) => data.value.toLowerCase() === tag.toLowerCase()
            );
            currentOptions[4].item[index].count += 1;
          }
        });
        currentOptions[4].item.sort((a, b) =>
          String(a.value).localeCompare(String(b.value))
        );
      });

      return currentOptions;
    });
  }, [posts, sharedWithOthers, sharedInCommunity]);

  const stripHTML = (htmlString) => {
    if (!htmlString) return "";
    let noImages = htmlString.replace(/<img[^>]*>/gi, "");
    let textOnly = noImages.replace(/<\/?[^>]+(>|$)/g, "");
    return textOnly.trim();
  };

  useEffect(() => {
    let selectedPost = [];
    if (selectedOption.type !== 0 && selectedOption.type !== 1) {
      selectedPost = posts.filter((post) => {
        let idx = -1;
        switch (selectedOption.type) {
          case 2:
            idx = post.courses.findIndex(
              (course) => course.id === parseInt(selectedOption.value)
            );
            return idx > -1;
          case 3:
            idx = post.events.findIndex(
              (event) => event.id === parseInt(selectedOption.value)
            );
            return idx > -1;
          case 5:
            idx = post.values.findIndex(
              (value) => value.id === parseInt(selectedOption.value)
            );
            return idx > -1;
          case 4:
            idx = post.hashtag.findIndex(
              (value) =>
                value.toLowerCase() === selectedOption.value.toLowerCase()
            );
            return idx > -1;
          default:
            return true;
        }
      });
    } else if (selectedOption.type === 0) {
      let reflectionId = sharedWithOthers.filter((data) => {
        if (parseInt(selectedOption.value) === parseInt(data.user_id)) {
          return data;
        }
      });
      let ids =
        reflectionId?.length > 0
          ? reflectionId[0]?.reflection_id
            ? reflectionId[0]?.reflection_id
            : []
          : [];
      for (let i = 0; i < ids.length; i++) {
        for (let j = 0; j < posts.length; j++) {
          if (parseInt(ids[i]) === parseInt(posts[j].reflection_id)) {
            selectedPost.push(posts[j]);
          }
        }
      }
    } else if (selectedOption.type === 1) {
      let reflectionId = sharedInCommunity.filter((data) => {
        if (parseInt(selectedOption.value) === parseInt(data.group_id)) {
          return data;
        }
      });
      let ids =
        reflectionId?.length > 0
          ? reflectionId[0]?.reflection_id
            ? reflectionId[0]?.reflection_id
            : []
          : [];
      for (let i = 0; i < ids.length; i++) {
        for (let j = 0; j < posts.length; j++) {
          if (parseInt(ids[i]) === parseInt(posts[j].reflection_id)) {
            selectedPost.push(posts[j]);
          }
        }
      }
    }

    // Search
    const filteredList = selectedPost
      .filter(
        (post) =>
          post.reflection_title
            .toLowerCase()
            .includes(searchField.toLowerCase()) ||
          stripHTML(post.reflection_content)
            .toLowerCase()
            .includes(searchField.toLowerCase())
      )
      .sort((a, b) => {
        let result = 0;

        if (sortBy === "created_on") {
          result =
            new Date(a.reflection_created_on) -
            new Date(b.reflection_created_on);
        } else if (sortBy === "title") {
          result = a.reflection_title.localeCompare(b.reflection_title);
        } else if (sortBy == "recentDate") {
          result =
            new Date(a.reflection_updated_on) -
            new Date(b.reflection_updated_on);
        } else if (sortBy == "like") {
          result = Number(a.likecount) - Number(b.likecount);
        } else if (sortBy == "comment") {
          result = Number(a.commentcount) - Number(b.commentcount);
        }

        return sortOrder === "asc" ? result : -result;
      });

    setFilteredPost(filteredList);
  }, [selectedOption, posts, searchField, sortOrder, sortBy]);

  useEffect(() => {
    dispatch(getReflectionFeedbackModels());
    dispatch(getReflectionFeedbackHistory(false));
    return () => {
      dispatch(hideShareto());
    };
  }, []);

  useEffect(() => {
    if (!props.loading) {
      document.body.addEventListener("scroll", scrollEnd);
    }
    return () => {
      document.body.removeEventListener("scroll", scrollEnd);
    };
  }, [props.loading]);

  const scrollEnd = () => {
    if (
      window.innerHeight + document.body.scrollTop ===
      document.body.scrollHeight
    ) {
      try {
        if (props.hasmore) {
          props.addJournalPage();
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  const setFilterValue = (type, value, data) => {
    if (data != true) {
      history.replace("/journal", null);
    }
    setSelectedOption({ type, value });
    // dispatch({
    //   type: "filterStatus",
    //   payload: { type, value },
    // });
  };

  useEffect(() => {
    setPostSelection([]);
  }, [posts]);

  useEffect(() => {
    if (
      props?.location?.state?.valueId > 0 &&
      localStorage.getItem("journalSave") != "true"
    ) {
      setFilterValue(5, props?.location?.state?.valueId, true);
    } else if (localStorage.getItem("journalSave") == "true") {
      history.replace("/journal", null);
      localStorage.removeItem("journalSave");
    }
  }, [props?.location?.state?.valueId]);

  const handleChange = (e) => {
    const { name, checked } = e.target;

    if (name === "checkAll") {
      if (checked) {
        setPostSelection(posts);
      } else {
        setPostSelection([]);
      }
    } else {
      if (checked) {
        const newList = [
          ...postSelection,
          ...posts.filter((item) => item.reflection_id.toString() === name),
        ];
        setPostSelection(newList);
      } else {
        const newList = postSelection.filter(
          (item) => item.reflection_id.toString() !== name
        );
        setPostSelection(newList);
      }
    }
  };

  const handleShareTo = () => {
    setDropdown(false);
    dispatch(showShareto());
    dispatch(fillList(postSelection));
  };

  const handleDelete = () => {
    setDropdown(false);

    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: `Are you sure to delete ${postSelection.length} ${postSelection.length > 1 ? "posts" : "post"
        }?`,
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        postSelection.map((item) =>
          axios
            .delete(`${serverUrl.Post}/${item.reflection_id}`)
            .then(() => {
              dispatch({
                type: POST_DELETED,
                payload: { postId: item.reflection_id },
              });
              dispatch(getShowcaseDetails());
              dispatch(getPosts());
              getSharedData();
            })
            .catch((err) => {
              tokenAuthorize(err?.response?.status);
              // Swal.close();
            })
        );
        Swal.fire({
          heightAuto: false,
          title: "Success",
          text: `${postSelection.length} ${postSelection.length > 1 ? "posts have" : "post has"
            }  been deleted`,
          icon: "success",
        });
      }
    });
  };

  useEffect(() => {
    dispatch(getUserPreference());
    const interval = setInterval(() => {
      resize();
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const resize = () => {
    if (window.innerWidth < 400) {
      setisMobile(true);
      setisGrid(false);
    } else {
      setisMobile(false);
      let data = localStorage.getItem("is_grid") == "true" ? true : false;
      setisGrid(data);
    }

    if (window.innerWidth < 1450 && window.innerWidth > 1150) {
      setisMobile1(true);
    } else {
      setisMobile1(false);
    }

    if (window.innerWidth > 1020 && window.innerWidth < 1150) {
      setisMobile2(true);
    } else {
      setisMobile2(false);
    }

    if (window.innerWidth > 768 && window.innerWidth < 920) {
      setisMobile3(true);
    } else {
      setisMobile3(false);
    }

    if (window.innerWidth < 768) {
      setisMobile4(true);
    } else {
      setisMobile4(false);
    }
  };

  useEffect(() => {
    let data = pagePreference["journal_is_grid"];
    setisGrid(data);
    localStorage.setItem("is_grid", data);
  }, [pagePreference]);

  const updatePreference = (data) => {
    if (isGrid != data) {
      pagePreference["journal_is_grid"] = !isGrid;
      localStorage.setItem("is_grid", !isGrid);
      setisGrid(!isGrid);
      dispatch(putUserPreference(pagePreference));
    }
  };

  const Loading = ({ active }) => {
    let style = active ? "w-10 h-10" : "hidden w-10 h-10";
    return (
      <div className="w-full flex justify-center">
        <img src={LOADING_GIF} alt="loading..." className={style} />
      </div>
    );
  };

  const createNewPost = () => {
    history.push(`${path}/new`, {
      src: location.pathname,
      valueId: props?.location?.state?.valueId,
      journal: true,
    });
  };

  const onExportPDF = () => { };

  const [submenuAnchor, setSubmenuAnchor] = useState(null);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const handleSubmenuOpen = (event, type) => {
    setSubmenuAnchor(event.currentTarget);
    setActiveSubmenu(type);
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchor(null);
    setActiveSubmenu(null);
  };
  const classes = useStyles();

  const handleSortChanges = (sortBy1, sortOrder) => {
    handleSubmenuClose();
    setSortMenu(null);
    setSortBy(sortBy1);
    setSortOrder(sortOrder);
    dispatch({
      type: "filterStatus",
      payload: { sortBy1: sortBy1, sortOrder: sortOrder },
    });
  };

  const sortOptions = [
    {
      key: "title",
      label: "Sort by Title",
      fields: [
        { value: "asc", label: "Ascending" },
        { value: "desc", label: "Descending" },
      ],
    },
    {
      key: "created_on",
      label: "Sort by Created Date",
      fields: [
        { value: "asc", label: "Ascending" },
        { value: "desc", label: "Descending" },
      ],
    },
    {
      key: "recentDate",
      label: "Sort by Recently Edited",
      fields: [
        { value: "asc", label: "Ascending" },
        { value: "desc", label: "Descending" },
      ],
    },
    {
      key: "like",
      label: "Sort by Number of Likes",
      fields: [
        { value: "asc", label: "Ascending" },
        { value: "desc", label: "Descending" },
      ],
    },
    {
      key: "comment",
      label: "Sort by Number of Comments",
      fields: [
        { value: "asc", label: "Ascending" },
        { value: "desc", label: "Descending" },
      ],
    },
  ];

  return (
    <>
      {/* <div className='lg:flex w-full pt-8 mb-8'> */}
      <div className="flex flex-col md:flex-col lg:flex-row pt-0 mb-8">
        <div className="flex flex-row-reverse lg:flex-col border-right-f1">
          <div className="px-4 w-full border-bottom-f1 pt-4 pb-3 md:pt-8 md:pb-6 box-border">
            <SearchBar setSearchField={setSearchField} />
          </div>
          <SidebarJournal
            data={filterOptions}
            selectedOption={selectedOption}
            setSelectedOption={setFilterValue}
            isJournal={true}
            valueId={
              props?.location?.state?.valueId > 0
                ? props?.location?.state?.valueId
                : 0
            }
            groupedValues={groupedValues}
          />
        </div>

        <div className="w-full border20pxbottomright lg:rounded-bl-none rounded-bl-2xl  backGroundColor pb-0 md:pb-6">
          <div className="flex justify-end cardBackgroundColor">
            <div className="block lg:hidden mx-5 mb-2 mt-2 ">
              <ButtonBlue
                onClick={createNewPost}
                title={"+ Add Post"}
                width="full"
              />
            </div>
          </div>
          <div className="grid md:grid-cols-2 grid-cols-1 pt-4 md:pt-7 pb-4 md:pb-7 px-5 cardBackgroundColor ">
            <div className="col-start-1 md:gap-4 flex flex-wrap items-center h-10">
              <div
                className={`${isGrid == true ? "visible" : "visible "
                  } ${"md:visible lg:visible xl:visible md:flex"}`}
              >
                Showing {filteredPost.length} of {totalPosts} posts
              </div>
              {selectEnabled && (
                <div
                  className={`${isGrid == true ? "visible" : "visible"
                    } ${"md:visible lg:visible xl:visible md:flex ml-2 checkGreen journalCheck flex"}`}
                >
                  {/* {isGrid == true &&  */}
                  <>
                    <label class="container-check">
                      <input
                        type="checkbox"
                        name="checkAll"
                        checked={
                          postSelection.length === 0
                            ? false
                            : postSelection.length === posts.length
                        }
                        onChange={handleChange}
                      />
                      <span class="checkmark mt-1"></span>
                    </label>
                    {postSelection.length}&nbsp;selected
                  </>
                </div>
              )}
            </div>
            <div className="col-start-1 sm:col-start-2 sm:mt-0 mt-3">
              <div className="flex float-right items-center justify-end flex-wrap gap-2">
                {postSelection.length > 0 && selectEnabled && (
                  <>
                    <Tooltip title={"Delete"} placement="top" arrow>
                      <ButtonCommonDelete
                        onClick={handleDelete}
                        className="cursor-pointer text-xs w-10 h-9 lg:text-sm rounded-lg py-2 flex justify-center items-center font-regular "
                      >
                        <FaTrashAlt
                          style={{ fontSize: "16px" }}
                          className="deleteColor"
                        />
                      </ButtonCommonDelete>
                    </Tooltip>
                    <Tooltip title={"Share"} placement="top" arrow>
                      <ButtonCommonTopNew
                        onClick={handleShareTo}
                        className="cursor-pointer text-xs w-10 h-9 lg:text-sm rounded-lg py-2 flex justify-center items-center font-regular "
                      >
                        <ShareIcon
                          style={{ fontSize: "16px" }}
                          className=" blueColor"
                        />
                      </ButtonCommonTopNew>
                    </Tooltip>
                  </>
                )}
                {selectEnabled && (
                  <Tooltip title={"Select Enabled"} placement="top" arrow>
                    <ButtonCommonTopNew
                      onClick={() => {
                        setSelectEnabled(!selectEnabled);
                      }}
                      className="cursor-pointer text-sm w-10 h-9 lg:text-sm rounded-lg flex justify-center items-center font-regular "
                    >
                      <DoneAllIcon
                        style={{ fontSize: "19px" }}
                        className=" blueColor"
                      />
                    </ButtonCommonTopNew>
                  </Tooltip>
                )}
                {!selectEnabled && (
                  <Tooltip title={"Select Disabled"} placement="top" arrow>
                    <ButtonCommonTopGrey
                      onClick={() => {
                        setSelectEnabled(!selectEnabled);
                      }}
                      className="cursor-pointer text-sm w-10 h-9 lg:text-sm rounded-lg flex justify-center items-center font-regular "
                    >
                      <RemoveDoneIcon
                        style={{ fontSize: "19px" }}
                        className=" greyColor"
                      />
                    </ButtonCommonTopGrey>
                  </Tooltip>
                )}

                <Tooltip title={"Sort"} placement="top" arrow>
                  <ButtonCommonTopNew
                    onClick={(e) => {
                      setSortMenu(e.currentTarget);
                    }}
                    className="cursor-pointer text-xs w-10 h-9 lg:text-sm rounded-lg py-2 flex justify-center items-center font-regular "
                  >
                    <SwapVertIcon
                      style={{ fontSize: "22px" }}
                      className=" blueColor"
                    />
                  </ButtonCommonTopNew>
                </Tooltip>
                {/* <MenuItemCard className="px-0 mx-0 hidden">
                  <Menu
                    id="simple-menu"
                    anchorEl={sortMenu}
                    keepMounted
                    onMouseLeave={handleSubmenuClose}
                    classes={{ paper: classes.customMenu }}
                    open={Boolean(sortMenu)}
                    onClose={() => {
                      setSortMenu(null);
                    }}
                    disableScrollLock={true}
                  >
                    <MenuItemCard>
                      <MenuItem
                        onMouseEnter={(e) => handleSubmenuOpen(e, "title")}
                        onClick={(e) => handleSubmenuOpen(e, "title")}
                        onMouseLeave={handleSubmenuClose}
                        className="flex gap-1.5 px-1"
                      >
                        <div className="flex justify-between w-full blackColor text-sm">
                          Sort by Title
                        </div>
                        {activeSubmenu === "title" && (
                          <Menu
                            anchorEl={submenuAnchor}
                            open={Boolean(submenuAnchor)}
                            onClose={handleSubmenuClose}
                            MenuListProps={{
                              sx: {
                                paddingTop: 0,
                                paddingBottom: 0,
                              },
                            }}
                            className={classes.nestedMenu}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            disableScrollLock={true}
                          >
                            <MenuItemCard
                              className={classes.nestedContent + " py-1"}
                            >
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor text-sm"
                                onClick={() => {
                                  handleSortChanges("title", "asc");
                                }}
                              >
                                <span className="text-sm"> Ascending</span>
                              </MenuItem>
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor text-sm"
                                onClick={() => {
                                  handleSortChanges("title", "desc");
                                }}
                              >
                                <span className="text-sm"> Descending</span>
                              </MenuItem>
                            </MenuItemCard>
                          </Menu>
                        )}
                      </MenuItem>
                      <MenuItem
                        onMouseEnter={(e) => handleSubmenuOpen(e, "date")}
                        onClick={(e) => handleSubmenuOpen(e, "date")}
                        onMouseLeave={handleSubmenuClose}
                        className="flex gap-1.5 px-1"
                      >
                        <div className="flex justify-between w-full blackColor text-sm">
                          Sort by Created Date
                        </div>
                        {activeSubmenu === "date" && (
                          <Menu
                            anchorEl={submenuAnchor}
                            open={Boolean(submenuAnchor)}
                            onMouseLeave={handleSubmenuClose}
                            className={classes.nestedMenu}
                            MenuListProps={{
                              sx: {
                                paddingTop: 0,
                                paddingBottom: 0,
                              },
                            }}
                            onClose={handleSubmenuClose}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            disableScrollLock={true}
                          >
                            <MenuItemCard
                              className={classes.nestedContent + " py-1"}
                            >
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor "
                                onClick={() => {
                                  handleSubmenuClose();
                                  handleSortChanges("created_on", "asc");
                                }}
                              >
                                <span className="text-sm"> Ascending</span>
                              </MenuItem>
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor text-sm "
                                onClick={() => {
                                  handleSubmenuClose();
                                  handleSortChanges("created_on", "desc");
                                }}
                              >
                                <span className="text-sm"> Descending</span>
                              </MenuItem>
                            </MenuItemCard>
                          </Menu>
                        )}
                      </MenuItem>
                    </MenuItemCard>
                  </Menu>
                </MenuItemCard> */}
                <MenuItemCard className="px-0 mx-0 hidden">
                  <Menu
                    id="simple-menu"
                    anchorEl={sortMenu}
                    keepMounted
                    onMouseLeave={handleSubmenuClose}
                    classes={{ paper: classes.customMenu }}
                    open={Boolean(sortMenu)}
                    onClose={() => setSortMenu(null)}
                    disableScrollLock={true}
                  >
                    <MenuItemCard>
                      {sortOptions.map((option) => (
                        <MenuItem
                          key={option.key}
                          onMouseEnter={(e) => handleSubmenuOpen(e, option.key)}
                          onClick={(e) => handleSubmenuOpen(e, option.key)}
                          onMouseLeave={handleSubmenuClose}
                          className="flex gap-1.5"
                          sx={{ padding: 0 }}
                        >
                          {sortBy == option.key ? (
                            <SideBarActiveDivNew className="flex justify-between w-full pl-3 pr-5 py-2 text-sm br-0">
                              {option.label}
                            </SideBarActiveDivNew>
                          ) : (
                            <div className="flex justify-between w-full pl-3 py-2 pr-5 text-sm br-0">
                              {option.label}
                            </div>
                          )}
                          {/* <div className="flex justify-between w-full blackColor text-sm"></div> */}

                          {activeSubmenu === option.key && (
                            <Menu
                              anchorEl={submenuAnchor}
                              open={Boolean(submenuAnchor)}
                              onClose={handleSubmenuClose}
                              MenuListProps={{
                                sx: { paddingTop: 0, paddingBottom: 0 },
                              }}
                              className={classes.nestedMenu}
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              disableScrollLock={true}
                            >
                              <MenuItemCard
                                className={classes.nestedContent + " py-1"}
                              >
                                {option.fields.map((field) => (
                                  <MenuItem
                                    key={field.value}
                                    sx={{ padding: 0 }}
                                    className="flex gap-1.5 px-1 blackColor text-sm"
                                    onClick={() => {
                                      handleSubmenuClose();
                                      handleSortChanges(
                                        option.key === "date"
                                          ? "created_on"
                                          : option.key,
                                        field.value
                                      );
                                    }}
                                  >
                                    {sortOrder == field.value &&
                                      sortBy == option.key ? (
                                      <SideBarActiveDivNew className="flex justify-between w-full pl-3 pr-5 py-2 text-sm br-0">
                                        {field.label}
                                      </SideBarActiveDivNew>
                                    ) : (
                                      <div className="flex justify-between w-full pl-3 pr-5 py-2 text-sm br-0">
                                        {field.label}
                                      </div>
                                    )}
                                  </MenuItem>
                                ))}
                              </MenuItemCard>
                            </Menu>
                          )}
                        </MenuItem>
                      ))}
                    </MenuItemCard>
                  </Menu>
                </MenuItemCard>

                <div
                  className={`p-1 rounded-lg flex items-center ${isGrid == false
                    ? "bg-blurred-gradient"
                    : "bg-blurred-gradientright"
                    } ${"cursor-pointer"}`}
                >
                  {isMobile == false ? (
                    isGrid == true ? (
                      <ButtonGridActiveNew
                        className="grid-div ml-1"
                        onClick={() => updatePreference(true)}
                      >
                        <ViewModule className={`${"gridicon-styleNew"}`} />
                      </ButtonGridActiveNew>
                    ) : (
                      <ButtonGridNew
                        className="grid-div ml-1"
                        onClick={() => updatePreference(true)}
                      >
                        <ViewModule className={`${"gridicon-styleNew"}`} />
                      </ButtonGridNew>
                    )
                  ) : (
                    ""
                  )}
                  {isGrid == false ? (
                    <ButtonGridActiveNew
                      className="grid-div"
                      onClick={() => updatePreference(false)}
                    >
                      <ViewList className={`${"listicon-styleNew"}`} />
                    </ButtonGridActiveNew>
                  ) : (
                    <ButtonGridNew
                      className="grid-div"
                      onClick={() => updatePreference(false)}
                    >
                      <ViewList className={`${"listicon-styleNew"}`} />
                    </ButtonGridNew>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            class={`${isGrid == true
              ? "md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5"
              : "grid-cols-1 mt-0"
              } ${"grid sm:p-5 p-2"}`}
          >
            {isGrid == false && (
              <>
                {/* <div className='flex mt-5 md:mt-0 justify-between md:justify-start '>
                                <div className='block md:hidden flex flex-row '>
                                    <div className='flex items-center checkGreen journalCheck flex'>
                                        <label class="container-check">
                                            <input type="checkbox" name='checkAll' checked={postSelection.length === 0 ? false : postSelection.length === posts.length} onChange={handleChange} />
                                            <span class="checkmark"></span>
                                        </label>
                                        <div className="ml-3">
                                            {postSelection.length} selected
                                        </div>
                                    </div>

                                </div>
                                <div className='block md:hidden pr-6 cursor-pointer'>
                                    <BsThreeDotsVertical className='w-6 h-6' onClick={() => setDropdown(!dropdown)} />
                                </div>
                                {(dropdown && (postSelection.length > 0)) && (
                                    <MenuItemCard className="block md:hidden absolute bg-white right-0 w-32 mt-6 p-3 rounded-md filter 
        drop-shadow transform -translate-x-0 z-10 translate-y-0 text-black"
                                    >
                                        <li className="space-y-2">

                                            {

                                                <>
                                                    <MenuItemDiv
                                                        className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                                                        onClick={handleShareTo}
                                                    >
                                                        <p className="text-sm font-semibold">Share</p>
                                                    </MenuItemDiv>
                                                    <MenuItemDiv
                                                        className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                                                        onClick={handleDelete}
                                                    >
                                                        <p className="text-sm font-semibold">Delete</p>
                                                    </MenuItemDiv>
                                                </>

                                            }
                                        </li>
                                    </MenuItemCard>
                                )}
                            </div>
                            <BgBlue className={`${isGrid == true ? 'hidden' : ''} ${'hidden md:grid grid-cols-8 h-16 bg-blue-no-hover rounded-lg w-full items-center text-white'}`}>
                                <div className='flex flex-row w-full md:grid grid-cols-7 col-span-7'>
                                    <div className='md:col-span-2 overflow-hidden'>
                                        <div className="grid grid-cols-3">
                                            <div className="md:col-span-1 -mt-2">
                                                <div className='inline-block'>
                                                    <div className='col-span-1 pl-5 xl:pl-10 flex items-center flex checkGreen journalCheck'>
                                                        <label class="container-check">
                                                            <input type="checkbox" name='checkAll' checked={postSelection.length === 0 ? false : postSelection.length === posts.length} onChange={handleChange} />
                                                            <span class="checkmark -mt-1"></span>
                                                        </label>
                                                        <label className='-ml-2'>No.</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`${isMobile3 || isMobile1 || isMobile2 ? "pl-4" : ""} ${"md:col-span-2 mt-1"}`}>
                                                Feature Image
                                            </div>
                                        </div>
                                    </div>
                                    <div className='md:col-span-5 md:ml-5 xl:ml-0 mt-1'>
                                        Title
                                    </div>
                                </div>
                                <div className='flex flex-col md:grid grid-cols-1 col-span-1'>
                                    <div className='flex justify-end items-center pr-6 cursor-pointer'>
                                        <BsThreeDotsVertical className='w-6 h-6' onClick={() => setDropdown(!dropdown)} />
                                    </div>
                                    { (dropdown && (postSelection.length > 0)) && (
                                        <MenuItemCard className="absolute bg-white right-0 w-24 md:w-32 lg:w-36 mt-6 p-3 rounded-md filter 
                                        drop-shadow transform -translate-x-10 z-10 translate-y-0 text-black"
                                        >
                                            <li className="md:pb-2">

                                                {
                                                    <>
                                                        <MenuItemDiv
                                                            className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                                                            onClick={handleShareTo}
                                                        >
                                                            <p className="text-sm ">Share</p>
                                                        </MenuItemDiv>
                                                        <MenuItemDiv
                                                            className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                                                            onClick={handleDelete}
                                                        >
                                                            <p className="text-sm ">Delete</p>
                                                        </MenuItemDiv>
                                                    </>
                                                }
                                            </li>
                                        </MenuItemCard>
                                    )}
                                </div>


                            </BgBlue> */}
                {filteredPost &&
                  filteredPost.map((item, index) => (
                    <JournalCards
                      item={item}
                      selection={postSelection.some(
                        (el) => el.reflection_id === item.reflection_id
                      )}
                      index={index}
                      key={index}
                      set={handleChange}
                      getShared={getSharedData}
                      historyEnabled={historyEnabled}
                      onClick={() => {
                        history.push(`/post/${item.reflection_id}`, {
                          src: "/journal",
                        });
                      }}
                      selectEnabled={selectEnabled}
                    />
                  ))}
              </>
            )}
            {isGrid && (
              <>
                {filteredPost &&
                  filteredPost.map((item, index) => (
                    <JournalGridCard
                      item={item}
                      selection={postSelection.some(
                        (el) => el.reflection_id === item.reflection_id
                      )}
                      index={index}
                      key={index}
                      set={handleChange}
                      getShared={getSharedData}
                      historyEnabled={historyEnabled}
                      onClick={() => {
                        history.push(`/post/${item.reflection_id}`, {
                          src: "/journal",
                        });
                      }}
                      selectEnabled={selectEnabled}
                    />
                  ))}
              </>
            )}
            <Loading active={props.loading} />
            {/* </div> */}
          </div>
        </div>
      </div>
      <ShareTo
        sharedComplete={(data) => setPostSelection(data)}
        journal={true}
      />
    </>
  );
}

// const mapStateToProps = (state) => {
//     return {
//         page        : state.journals.page,
//         journal     : state.journals.posts,
//         loading     : state.journals.loading,
//         hasmore     : state.journals.hasmore,
//         spage       : state.journals.spage
//     }
// }

// const mapDispatchToProps = (dispatch) => {
//     return {
//         getJournalsFetch: (page) => {
//             Axios.get(`https://my-json-server.typicode.com/ventrix135/database1/JournalCardData?_page=${page}&_limit=3`)
//             .then(response => {
//                 const journals = response
//                 if(journals.data.length < 3) {
//                     dispatch({type: TOGGLE_JOURNAL_MORE, journals})
//                 } else {
//                     dispatch({type: GET_JOURNAL_SUCCESS, journals})
//                 }
//             })
//         },
//         addJournalPage: () => {
//             dispatch({type: ADD_JOURNAL_PAGE })
//         },
//         saveJournalPage: () => {
//             dispatch({type: SAVE_JOURNAL_PAGE })
//         }
//     }
// }

export default Journal;
